import { Device } from '@/api';
import { createContext } from 'react';

export interface DevicesContextData {
    devices: Device[];
}

export const DevicesContext = createContext<DevicesContextData | undefined>(
    undefined
);
